import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import WeekPicks from './components/WeekPicks';
import UserPicks from './components/UserPicks';
import LoginPage from './components/LoginPage';
import SeasonToggle from './components/SeasonToggle';
import { SeasonProvider } from './SeasonContext';

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token || isTokenExpired(token)) {
    localStorage.removeItem('token');
    return <Navigate to="/login" replace />;
  }
  return (
    <>
      <SeasonToggle />
      {children}
    </>
  );
};

function App() {
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && isTokenExpired(token)) {
      localStorage.removeItem('token');
    }
  }, []);

  return (
    <SeasonProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <WeekPicks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/weekpicks"
            element={
              <ProtectedRoute>
                <WeekPicks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user/:userId"
            element={
              <ProtectedRoute>
                <UserPicks />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </SeasonProvider>
  );
}

export default App;
